export default {
    l_User_name: "Қолданушы аты",
    l_Phone: "Телефон",
    l_User_password: "Қолданушы құпия сөзі",
    l_Forgot_password: "Құпия сөзді қалпына келтіру",
    l_Login: "Кіру",
    l_Sign_out: "Шығу",
    l_EmailorPasswordisWrong: "Электрондық пошта немесе құпия сөз қате",
    l_User: "Қолданушы",
    l_Payments: "Төлемдер",
    l_Promocodes: "Промокоды",
    l_Messages: "Хабарламалар",
    l_Consolidations: "Біріктірулер",
    l_Courier_Orders: "Курьердегі тапсырыстар",
    l_Almaty: "Алматы",
    l_Name: "Аты",
    l_Add: "Қосу",
    l_Action: "Әрекет",
    l_Temu_return_back: "Temu складына қайтару",
    l_Return_excel: "Қайтару M-Batch(Excel)",
    l_Update: "Жаңарту",
    l_Edit: "Өңдеу",
    l_Submit: "Жіберу",
    l_Cancel: "Болдырмау",
    l_Are_you_sure_delete_this_task: "Бұл тапсырманы жойғыңыз келе ме?",
    l_Yes: "Иә",
    l_No: "Жоқ",
    l_Last_trackcodes: "Соңғы тректер",
    l_Tracking_number: "Бақылау нөмірі",
    l_Internal_Tracking_number: "Ішкі бақылау нөмірі",
    l_Medium_batch_count: "Meduim batch саны",
    l_Actual_Price: "Нақты баға",
    l_Estimated_price: "Болжалды баға",
    l_Actual_weight: "Нақты салмақ",
    l_kg: "кг",
    l_Estimated_weight: "Есептік салмақ",
    l_Delivery_country: "Жеткізу елі",
    l_Delivery_type: "Жеткізу түрі",
    l_Address: "Мекенжай",
    l_Execution_status: "Орындалу статусы",
    l_Cargo: "Тауар",
    l_Sign_up: "Тіркелу",
    l_Next: "Келесі",
    l_Verify_code: "Кодты тексеру",
    l_Set_password: "Құпия сөзді орнату",
    l_Confirm_password: "Құпия сөзді растау",
    l_Get_SMS: "SMS алу",
    l_Get_the_verification_code_first: "Алдымен растау кодын алыңыз",
    l_Confirm_password_error: "Құпия сөзді растау қатесі",
    l_Phone_number: "Телефон нөмірі",
    l_Password: "Пароль",
    l_Wrong_password_format: "Құпия сөз форматы қате",
    l_Please_enter_phone_number: "Телефон нөмірді енгізіңіз",
    l_Please_enter_sms: "SMS енгізіңіз",
    l_My_addresses: "Мекенжайларым",
    l_Accepted_time: "Қабылдаған уақыт",
    l_My_parcels: "Cәлемдемелерім",
    l_Total_weight: "Толық салмағы",
    l_Remark_time: "Белгіленген күн",
    l_Remark_JPID: "Белгілеген JPID",
    l_Buy_instead_of_me: "Сіз үшін сатып аламыз",
    l_Accepted_JPID: "Қабылдаған JPID",
    l_Accepted_stationCode: "Қабылдаған бөлімше",
    l_Remark_stationCode: "Белгілеген бөлімше",
    l_On_shelf: "Сөреде",
    l_Personal_data: "Жеке деректер",
    l_Update_password: "Құпия сөзді жаңарту",
    l_Old_Password: "Ескі құпия сөз",
    l_New_Password: "Жаңа құпия сөз",
    l_Successed: "Сәтті",
    l_Personal_information: "Жеке ақпарат",
    l_User_list: "Қолданушылар тізімі",
    l_Email: "Электрондық пошта",
    l_Add_user: "Қолданушыны қосу",
    l_Full_name: "Аты-жөні",
    l_IIN: "ЖСН",
    l_ID_number: "Жеке куәлік нөмірі",
    l_Issuing_authority: "Берген орган",
    l_Issue_date: "Берілген күні",
    l_Validity: "Қолданылу мерзімі",
    l_Delivery_address: "Жеткізу мекенжайы",
    l_Town: "Облыс-Қала/Аудан",
    l_Street: "Көше",
    l_House: "Үй",
    l_Postcode: "Пошта индексі",
    l_Identity_card: "Жеке куәлік",
    l_Facial: "Беттік жағы",
    l_Negotiable: "Артқы жағы",
    l_Draw_a_signature: "Қолтаңбаны салу",
    l_Or_download_the_signed_contract: "Немесе қол қойылған келісімшартты жүктеп қосыңыз",
    l_Note: "Ескертпелер",
    l_Precautions_for_uploading_pictures: "Қосылған құжаттың сапасы жақсы болуы керек. Сурет 1 МБ-тан аспауы керек.",
    l_Click_or_drag_ile_to_this_area_to_upload: "Файлды жүктеп қосу үшін осы аймаққа басыңыз немесе файлды әкеліп қойыңыз",
    l_My_order: "Тапсырысым",
    l_Track_code: "Трек-код",
    l_Recipient: "Расталған",
    l_Cargo_name: "Жүк атауы",
    l_Declared_price: "Жарияланған баға",
    l_Date: "Күн",
    l_Delivery_cost: "Жеткізу құны",
    l_Dispatch_country: "Жіберу елі",
    l_Delivery_method: "Жеткізу әдісі",
    l_Order: "Тапсырыс",
    l_Shipping_country: "Жеткізу елі",
    l_Transportation_method: "Тасымалдау әдісі",
    l_Price: "Баға",
    l_Quantity: "Саны",
    l_Total_cost: "Жалпы құн",
    l_Category: "Категория",
    l_Weapons_and_explosive_materials: "Қару және жарылғыш материалдар",
    l_Alcoholic_drinks: "Алкогольдік сусындар",
    l_Sprays_and_aerosols: "Спреи және аэрозольдер",
    l_Medicines_without_a_doctors_prescription: "Дәрігердің рецептісіз дәрі-дәрмектер",
    l_radioactive_elements: "Радиоактивті элементтер",
    l_Animals_and_plants: "Жануарлар мен өсімдіктер",
    l_ALL_RIGHTS_RESERVED: "БАРЛЫҚ ҚҰҚЫҚТАР САҚТАЛҒАН",
    l_Contact: "Контакт",
    l_About_us: "Біз туралы",
    l_The_shops: "Дүкендер",
    l_How_it_works: "Бұл қалай жұмыс істейді?",
    l_Rates: "Тарифтер",
    l_Frequently_asked_Questions: "Жиі қойылатын сұрақтар",
    l_Prohibited_Items: "Тыйым салынған заттар",
    l_Privacy_Policy: "Құпиялылық саясаты",
    l_Weight: "Салмақ",
    l_Declaration: "Декларация",
    l_Pay: "Төлеу",
    l_Provinces: "Аудандар",
    l_Country: "Мемлекет",
    l_Full_address: "Толық мекенжай",
    l_MY_ADDRESS_IN_CHINA_FOR_AUTO_DELIVERY: "КӨЛІКПЕН ЖЕТКІЗУ ҮШІН ҚЫТАЙДАҒЫ МЕКЕНЖАЙ",
    l_Add_product: "Тауар қосу",
    l_Please_enter_quantity: "Санын енгізіңіз",
    l_The_maximum_number_is: "Ең көп сан",
    l_China: "Қытай",
    l_Auto_delivery: "Автожеткізу",
    l_To_avoid_problems_during_customs_clearance_please_enter_a_detailed_description_of_the_product_name_in_Russian: "Кедендік тазалау кезінде мәселердің алдын алу үшін тауардың атауының орыс тілінде нақты сипаттамасын енгізуді сұраймыз.",
    l_Later_confirm: "Кейінірек растау",
    l_Confirm: "Растау",
    l_Succeed: "Операция сәтті өтті",
    l_Provide_a_link_to_the_product_we_will_buy_and_bring_it_for_you: "Тауардың сілтемесін жіберіңіз, біз оны сіз үшін сатып алып әкелеміз!",
    l_Cargo_link: "Тауар сілтемесі",
    l_Additional_comment: "Қосымша түсініктеме",
    l_Are_you_willing_to_buy_if_the_price_fluctuates_up_to_7: "Егер баға 7% -ға дейін ауытқыса, сіз сатып алуға дайынсыз ба?",
    l_size: "Өлшем",
    l_Color: "Түс",
    l_Delivery_price: "Жеткізу бағасы",
    l_Promo_codes: "Промокодтар",
    l_Whether_the_payment_is_completed: "Төлем аяқталды ма?",
    l_Completed: "Аяқталды",
    l_Not_completed: "Аяқталмаған",
    l_Image_must_smaller_than_3MB: "Сурет 3 МБ-тан аз болуы керек!",
    l_Image_must_smaller_than_2MB: "Сурет 2 МБ-тан аз болуы керек!",
    l_Image_format_error: "Суреттің форматы қате!",
    l_Analytics: "Аналитика",
    l_Status: "Күйі",
    l_Order_id: "Тапсырыс идентификаторы",
    l_Traking_number: "Трэк код",
    l_Amount: "Сома",
    l_Payment_metehod: "Төлем әдісі",
    l_Payment: "Төлем",
    l_First_name: "Аты-жөні",
    l_Last_name: "Тегі",
    l_Type: "Типі",
    l_Client: "Клиент",
    l_Admin: "Админ",
    l_Last_login: "Соңғы кіру",
    l_Register: "Тіркелу",
    l_Verified: "Тексерілген",
    l_Not_verified: "Тексеруден өтпеді",
    l_All: "Барлығы",
    l_Search: "Іздеу",
    l_Statuses: "Күйлер",
    l_Start_country: "Шығатын ел",
    l_End_country: "Жететін ел",
    l_Sort: "Сұрыптау",
    l_Add_time: "Уақыт қосу",
    l_Update_time: "Уақытты өзгерту",
    l_Ascending: "Өсу ретімен",
    l_Descending: "Кему ретімен",
    l_Create_time: "Құрылған уақыт",
    l_Message: "Хабарлама",
    l_Send_message: "Хабарлама жіберу",
    l_Internal_tracking_number: "Ішкі бақылау нөмірі",
    l_Shopping_instead: "Орнына сатып алу",
    l_Size: "Өлшем",
    l_Description: "Сипаттамасы",
    l_Link: "Сілтеме",
    l_City: "Қала",
    l_All_cargo: "Барлық тауарлар",
    l_Volume: "Көлемі",
    l_Height: "Биіктік",
    l_Paid: "Төленген",
    l_Unpaid: "Төленбеген",
    l_Declaration_verify: "Декларацияны тексеру",
    l_Update_date: "Жаңарту күні",
    l_Add_date: "Күн қосу",
    l_Add_to_consolidation: "Біріктіруге қосу",
    l_Consolidation: "Біріктіру",
    l_Consolidation_id: "Біріктіру ID",
    l_Add_type: "Түрді қосу",
    l_Add_new: "Жаңа қосу",
    l_Contractor: "Мердігер",
    l_Selected_order_quantity: "Таңдалған тапсырыс саны",
    l_Flight_number: "Рейс нөмірі",
    l_Execution_date: "Орындау күні",
    l_Document: "Құжат",
    l_Add_order: "Тапсырысты қосу",
    l_Can_choose_to_consolidation: "Біріктіруді таңдай алады",
    l_төленген_сома: "Төленген сома",
    l_Payment_method: "Төлем әдісі",
    l_Card: "карта",
    l_Cash: "Қолма-қол ақша",
    l_External_ID: "Сыртқы идентификатор",
    l_Verification_succeeded: "Тексеру сәтті өтті",
    l_Verification_failed: "Тексеру сәтсіз аяқталды",
    l_Car_number: "Автокөлік нөмірі",
    l_trailer_car_number: "Тіркеме вагонының нөмірі",
    l_Foreign_warehouse: "Шетел қоймасы",
    l_Almaty_warehouse: "Алматы қоймасы",
    l_Info: "Ақпарат",
    l_Payment_amount: "Төлем сомасы",
    l_Automatic_storage_filter_cleared_when_refresh: "Автоматты сақтау сүзгісі жаңарту кезінде тазаланады",
    l_Not_found: "Табылмады",
    l_Contract_template: "Келісім-шарт үлгісі",
    l_File_format_error: "Файл пішімі дұрыс емес!",
    l_Back_home_page: "Өкінішке орай, сіз кірген бет табылмалы.",
    l_Picked_up: "Алып кетті",
    l_Not_picked_up: "Алған жоқ",
    l_Payment_status: "Төлем күйі",
    l_Ready_to_ship: "Жіберуге дайын",
    l_Belongs_category: "Тәуелді түрі",
    l_File: "Файл",
    l_Poster: "Постер",
    l_format_error: "Форматы қате",
    l_TN_CODE: "TNVED коды",
    l_Other: "Басқа",
    l_Company: "Компания",
    l_Order_tracking: "Тапсырысты қадағалау",
    l_Not_fount: "Табылмады",
    l_Submit_and_print_label: "Жіберу және label шығару",
    l_Are_you_sure_update_password: "Құпия сөзді шынымен жаңартасыз ба?",
    l_Print: "Басып шығару",
    l_Operator: "Оператор",
    l_Russian_language: "Орыс тілінде",
    l_Print_label: "Label шығару",
    l_Warehouse: "Қойма",
    l_Checking: "Тексерілуде",
    l_Verification_failed_description: "Тексеруден өтпеу себебі",
    l_Select: "Таңдау",
    l_Gross_weight: "Брутто салмағы",
    l_Join_warehouse: "Қоймаға қосу",
    l_Batch_number: "Топтама нөмірі",
    l_Unclaimed_order: "Иесіз тапсырыс",
    l_China_batch: "CN batch",
    l_Reject_order: "Тапсырысты қабылдамау",
    l_Mini_batch: "Mini batch",
    l_Kazakhstan_batch: "KZ batch",
    l_Branch_warehouse: "Бөлімше",
    l_Branch_statistic: "Бөлімше статистикасы",
    l_Driver: "Жүргізуші",
    l_Dest_station: "Межелі станция",
    count: "Саны",
    ARRIVAL_BRANCH: "Бөлімшеге жетті",
    DELIVERED: "Алып кетті",
    ARRIVAL_SHELF: "Сөреге қойылды",
    INNER_LOGISTICS_FINISH: "Ішкі логистика аяқталды",
    WAIT: "Күту",
    RETURN: "Қайтарылды",
    l_Batch: "Batch",
    l_Shelf: "Сөре",
    l_Add_to_shelf: "Сөреге қосу",
    l_Data: "Деректер",
    l_Settings: "Параметрлер",
    l_Creator: "Құрушы",
    l_Shelf_number: "Сөре нөмірі",
    l_Sorting_center: "Сұрыптау орталығы",
    l_Pick_up: "Алып кету",
    l_Scan: "Сканерлеу",
    l_Last_six_digits_of_mobile_number: "Телефон нөміріңіздің соңғы алты саны",
    l_Branch_batch: "Branch batch",
    l_Arrived_to_branch: "Филиалға жетті",
    l_Arrived: "Жетті",
    l_App_version: "Қолданба нұсқасы",
    l_App_version_title: "Нұсқа атауы",
    l_App_version_content: "Нұсқа мазмұны",
    l_App_version_system: "Қолданба жүйесі",
    l_Version: "Нұсқа нөмірі",
    l_Force_update: "Мәжбүрлеп жаңарту керек пе?",
    l_Published: "Жарияланған",
    l_Unpublished: "Жарияланбаған",
    l_Export_excel: "Excel шығару",
    l_Work_time: "Жұмыс уақыты",
    l_Manager: "Басқарушы",
    l_Province: "Облыс",
    l_Remark: "Ескертпе",
    l_Start: "Басталуы",
    l_End: "Аяқталуы",
    l_Do_not_add_randomly: "Кездейсоқ қосуға болмайды!",
    l_Find_branch: "Филиал анықтау",
    l_Refresh: "Жаңарту",
    l_Has_photo: "Суреті бар",
    l_Valid_time: "Жарамды уақыты",
    l_Visible_state: "Көріну күйі",
    l_File_update_time: "Файлды жаңарту уақыты",
    l_Time: "Уақыт",
    l_Created: "Құрылды",
    l_Group_payment: "Топтық төлем",
    l_Permission: "Рұқсат",
    l_System: "Жүйе",
    l_Info_api: "API ақпараты",
    l_Road_type: "Жол түрі",
    l_Official: "Ресми",
    l_Commerce: "Коммерция",
    l_Recommended_shelf: "Ұсынылған сөре",
    l_Amount_payable_by_the_client: "Клиент төлеуге тиісті сома",
    l_Payment_completed: "Төлем орындалды",
    l_Error_batch: "Қайтару batch",
    l_Error_order: "Қайтару тапсырыс",
    l_Error_mini_batch: "Қайтару mini batch",
    l_Work: "Жұмыс",
    l_China_logistics: "Қытай логистикасы",
    l_Receiver: "Қабылдаушы",
    l_Transport_day: "Тасымалдау күні",
    l_Day: "Күн",
    l_tel_merge: "Телефондарды біріктіру",
    l_Abnormal_order: "Мәселелі тапсырыс",
    l_Customs: "Кеден",
    l_Contract: "Келісімшарт",
    l_Invoice: "Invoice",
    l_Filter: "Фильтр",
    l_CN_category_id: "CN категориясының идентификаторы",
    l_Prohibited_catgegories: "Тыйым салынған санат",
    l_Error: "Техникалық қателік орын алды! IT бөліміне скрин жіберіңіз.",
    l_Those_whose_weight_is_over_31_kg: "Салмағы 31 кг-нан асқандар",
    l_The_price_is_more_than_1000: "Бағасы 1000$ асқандар",
    l_Price_over_1000_and_weight_over_31_kg: "Бағасы 1000$ асқандар және салмағы 31 кгнан асқандар",
    l_Net_weight: "Таза салмақ",
    l_Overall_weight: "Жалпы салмақ",
    l_History: "Тарихы",
    l_Updated_time: "Өзгертілген уақыт",
    l_Order_count: "Тапсырыс саны",
    l_Unknown: "Белгісіз",
    l_Mini_batch_count: "Mini batch саны",
    l_Return_order: "қайтарылған тапсырыс",
    l_Change_branch: "Бөлімше өзгерту",
    l_Image: "Сурет",
    l_Search_in_shelf: "Сөреден іздеу",
    l_Translation: "Аударма",
    l_Primary_language: "Бастапқы тіл",
    l_Content: "Мазмұны",
    l_Translated_language: "Aударылған тіл",
    l_Check_the_category_of_KTZ: "KTZ категориясын тексеру",
    l_There_is_KTZ_category: "KTZ категориясы бар",
    l_There_is_no_category_KTZ: "KTZ категориясы жок",
    l_Statistic: "Статистика",
    l_Are_you_sure_of_the_correctness_of_the_data: "Деректердің дұрыстығына сенімдісіз бе?",
    l_China_warehouse: "Қытай қоймасы",
    l_Sorting: "Сұрыптау",
    l_Role: "Рөл",
    l_Stay_branch_day: "Бөлімшеде тұрған күн (мин)",
    l_Min_weight: "Салмақ (мин)",
    l_Menu: "Меню",
    l_Left_from_Almaty: "Алматыдан шықты",
    l_Left_from_China: "Қытайдан шықты",
    l_Almaty_warehouse_received: "Алматы қоймасы қабылдап алды",
    l_China_warehouse_received: "Қытай қоймасы қабылдап алды",
    l_Jpid_build_by_minibatch: "Minibatch-ка салған jpid",
    l_Weighed_id: "Салмағын өлшеген id",
    l_Close: "Жабу",
    l_Article: "Мақала",
    l_Employees: "Қызметкерлер",
    l_Visibility: "Көріну",
    l_Can_view: "Көруге болады",
    l_Admin_worker: "Админ қызметкері",
    l_Web: "Веб",
    l_General: "Жалпы",
    l_Door_to_door: "Маған жеткізу",
    l_Pending_orders: "Күтудегі тапсырыстар",
    l_In_delivery: "Жеткізілуде",
    l_Received: "Алынды",
    l_Reject: "Қабылдамау",
    l_Pending: "Күтуде",
    l_Supervision: "Қадағалау",
    l_Language: "Тілі",
    l_Agent: "Агент",
    l_My_Statistics: "Менің статистикам",
    l_Count_Stats: "Санақ статистикасы",
    l_Number_of_products_that_do_not_match_the_branch: "Филиал сәйкес емес тауарлар саны",
    l_Quantity_of_goods: "Тауарлар саны",
    l_Batch_statistics: "Batch статистика",
    l_Returned_to_China_Courier: "Қытай курьеріне қайтарылды",
    l_Feedback: "Кері байланыс",
    l_Accepted: "Қабылданды",
    l_In_progress: "Орындалуда",
    l_Weight_change_history: "Салмақ өзгерту тарихы",
    l_Public_document: "Қоғамдық құжат",
    l_Recovery: "Қалпына келтіру",
    l_Logistic: "Логистика",
    l_Regional_center: "Облыс (Қала) орталығы",
    l_Internal_logistics: "Ішкі логистика",
    l_Branch: "Бөлімше",
    l_Dont_match: "Сәйкес емес",
    l_Additional_document: "Қосымша құжат",
    l_Weight_difference: "Салмақ айырмашылығы",
    l_Dead_goods: "Өлі тауар",
    l_List: "Тізімі",
    l_Result: "Нәтиже",
    l_Reason: "Себеп",
    l_Negotiate_order_prices: "Тапсырыс бағасын келісу",
    l_Negotiate_road_prices: "Жол бағасын келісу",
    l_Bank_account: "Банк шоты",
    l_Finish: "Аяқтау",
    l_Revise: "Қайта тексеру",
    l_Alert_on_revision: "Тексеру уақыты басталмады",
    l_Save: "Сақтау",
    l_Create: "Құру",
    l_Schedule: "Кесте",
    l_Coming: "Жолда",
    l_Reception: "Қабылдау",
    l_Put_on_the_shelf: "Сөреге қою",
    l_Distribution: "Тарату",
    l_Result_status: "Нәтиже күйі",
    l_Tag: "Тег",
    l_Average_weight: "Орташа салмақ",
    l_Dependent_region: "Тәуелді аймақ",
    l_Reset_permission: "Рұқсатты қалпына келтіру",
    l_Cannot_be_deleted: "Жою мүмкін емес",
    l_Region: "Регион",
    l_Operator_statistic: "Оператор статистикасы",
    l_People_who_uploaded_the_document: "Құжатты жүктеген адамдар",
    l_Reset: "Қалпына келтіру",
    l_Rejected_order: "Бастартылған тапсырыс",
    l_Warning_Has_an_impact_on_statistics: "Ескерту! Статистикаға әсері бар.",
    l_Fragile_products: "Оңай сынатын тауарлар",
    l_Sorting_machine: "Сұрыптау аппарат",
    l_Unique: "Бірегей",
    l_Repeated: "Қайталанатын",
    l_Machine: "Аппарат",
    l_Ticket: "Билет",
    l_Work_schedule: "Жұмыс кестесі",
    l_App_service: "App қызметі",
    l_Order_status: "Тапсырыс күйі",
    l_In_several_branches: "Бірнеше бөлімшеде",
    l_Not_in_database: "Базада жоқ",
    l_Correct: "Дұрыс",
    l_Revision: "Ревизия",
    l_Detail: "Толық мәлімет",
    l_Answer: "Жауап",
    l_Receive_client: "Клиенттен қабылдау",
    l_Work_order: "Жұмыс тапсырысы",
    l_Order_code: "Тауар-код",
    l_Send_address: "Жіберу мекенжайы",
    l_Receive_name: "Алушының аты",
    l_Receive_contact: "Алушы контактісі",
    l_Receive_address: "Алушы мекенжайы",
    l_Express_Company_Id: "Экспресс компания идентификаторы",
    l_Express_Dealer: "Express жеткізуші",
    l_Express_Dealer_Contact: "Жеткізуші контактісі",
    l_Compensate_Amount: "Компенсация сомасы",
    l_Reply_type: "Жауап түрі",
    l_Handle_result: "Нәтижені өңдеу",
    l_Call_result: "Қоңырау нәтижесі",
    l_Pay_amount: "Тауар бағасы",
    l_Compensate_state: "Компенсация күйі",
    l_sign_state: "Белгі күйі",
    l_Replied: "Жауап берді",
    l_Not_replied: "Жауап берілген жоқ",
    l_Orders_in_shelf: "Сөредегі тауарлар саны",
    l_Tariff: "Тариф",
    l_Filter_settings: "Сүзгі баптаулары",
    l_PDD_received: "PDD қабылдады",
    l_Wallet: "Шот",
    l_Bonus: "Бонус",
    l_Refund_account: "Қайтарымға жауапты",
    l_Duty: "Жауапты жақ",
    l_The_call_was_connected_but_there_was_no_response: "Қоңырау қосылды, бірақ жауап болмады",
    l_Wrong_number: "Қате нөмір",
    l_Phone_is_busy: "Телефон бос емес",
    l_No_response: "Жауап жоқ",
    l_Other_person: "Басқа адам",
    l_By_default: "Әдепкі бойынша",
    l_Not_signed: "Қол қойылған жоқ",
    l_Signed: "Қол қойылған",
    l_Cargo_company: "Жүк тасымалдау компаниясы",
    l_Seller: "Сатушы",
    l_Will_not_compensate: "Өтеу төленбейді",
    l_Will_compensate: "Өтемдеймін",
    l_Answered: "Кім жауап берді",
    l_Replied_at: "Жауап берілген уақыт",
    l_Consumer: "Тұтынушы",
    l_Multi: "Көп",
    l_Normal: "Қалыпты",
    l_Added_to_task: "Тапсырмаға қосылды",
    l_Big_box: "Үлкен қорап",
    l_Task: "Тапсырма",
    l_Has: "бар",
    l_None: "Жоқ",
    l_All_answers: "Барлық жауаптар",
    l_Already_scanned: "Сканерленген!",
    l_Terminal: "Терминал",
    l_The_branch_does_not_match: "Филиал сәйкес емес",
    l_End_time: "Аяқталу уақыт",
    l_Left: "Шықты",
    l_Reached_the_center: "Орталыққа жетті",
    l_Left_from_the_center: "Орталықтан шықты",
    l_Scan_time: "Сканерлеу уақыт",
    l_App_news: "Қолданба жаңалықтары",
    l_Title: "Тақырып",
    l_Check_list: "Тексеру тізімі",
    l_Total_average: "Жалпы орташа балл",
    l_Operation_JPID: "JPID операциясы",
    l_Average_score: "Орташа балл",
    l_Criteria_name: "Шарттар атауы",
    l_Score: "Ұпай",
    l_Check_list_add: "Тексеру тізімін қосу",
    l_Criteria_add: "Шарттарды қосу",
    l_Checked_date: "Тексеру күні",
    l_User_restore: "Қолданушыны қалпына келтіру",
    l_App_articles: "Қолданба мақалалары",
    l_Partner: "Серіктес",
    l_News: "Жаңалықтар",
    l_Lost: "Адасқан",
    l_Video: "Кескін",
    l_Statement: "Өтініш",
    l_Serve_speed: "Жіберу жылдамдығы",
    l_Send_by_file: "Файл арқылы жіберу",
    l_Send_one: "Біртіндеп жіберу",
    l_Late_goods: "Кешіккен тауар",
    l_Warehouse_payment: "Склад төлем",
    l_Registration: "Тіркеу",
    l_Questions: "Сұрақтар",
    l_Question: "Сұрақ",
    l_Rating: "Бағалаулар",
    l_Star: "Жұлдыз",
    l_Sender: "Жіберуші",
    l_Rate_type: "Бағалау түрі",
    l_Rate_question: "Сауалнама",
    l_Scan_with_app: "Jana Post қосымшасымен сканер жасаңыз",
    l_Destroy: "Жою",
    l_Sold: "Сатылды",
    l_Burned: "Өртенген",
    l_Rework: "Қайта өңдеу",
    l_Worker: "Жұмысшы",
    l_Delivery: "Орындалу уақыты",
    l_Send: "Жіберу",
    l_Destroyed: "Жойылды",
    l_File_must_be_less_than_5_MB: "Файл 5 МБ-тан аз болуы керек!",
    l_Finish_sorting: "Сұрыптау аяқталды",
    l_Barcode: "Штрих-код",
    l_Inner_logistic_finish: "Ішкі логистика аяқталды",
    l_Table: "Кесте",
    l_Charts: "Диаграммалар",
    l_Option: "Талдау",
    l_Options: "Талдаулар",
    l_Results: "Қорытынды жауап",
    l_Partners: "Серіктестер",
    l_Resume: "Резюме",
    l_Finance: "Қаржы",
    l_Scanzona: "Зонада",
    l_Scanned_in_zona: "Зонада сканерленген",
    l_Complaints: "Шағымдар",
    l_Responsible_department: "Жауапты бөлім",
    l_User_feedback: "Қолданушының пікірі",
    l_Employee_discount: "Қызметкерлерге жеңілдік",
    l_Transportation_time: "Тасымалдау уақыты",
    l_Hour: "Сағат",
    l_Add_filials: "Филиалдар қосу",
    l_Filial_list: "Филиалдар тізімі",
    l_Partnership: "Әріптестік",
    l_Count: "Бөлінген орын саны",
    l_Branches_for_partners: "Партнерлерге ашылатын филиалдар",
    l_Plomb: "Пломба",
    l_Latitude: "Ендік",
    l_Longitude: "Бойлық",
    l_By_file: "Файл бойынша",
    l_By_filter: "Сұрыптау бойынша",
    l_User_count: "Қолданушы саны",
    l_Name_fill: "Аты жөніңіз",
    l_individualEntrepreneur: "Сізде ИП ашылған ба? ",
    l_Address_link: "Бөлімше ашатын орынды 2GIS қосымшасынан сілтемесін енгізіңіз және кв.метрін көрсетіп қысқаша ақпарат жазыңыз",
    l_Have_you_ordered: "JANA POST компаниясы арқылы тапсырыс беріп көргенсіз бе? (JP код жазу керек)",
    l_Address_fill: "JANA POST компаниясының талаптарына сай бөлімше ашатын орыныңыз бар ма? ",
    l_Based_on_your_current_location_are_you_in_Kazahstan: "Қазіргі орналасқан жеріңізге байланысты сіз Қазақстандасыз",
    l_Based_on_your_current_location_are_you_in_Uzbekistan: "Қазіргі орналасқан жеріңізге байланысты сіз Өзбекстандасыз",
    l_Based_on_your_current_location_are_you_in_Kyrgyzstan: "Қазіргі орналасқан жеріңізге байланысты сіз Қырғызтандасыз",
    l_Based_on_your_current_location_are_you_in_Tajikistan: "Қазіргі орналасқан жеріңізге байланысты сіз Тәжікстандасыз",
    l_Based_on_your_current_location_are_you_in_Mongolia: "Қазіргі орналасқан жеріңізге байланысты сіз Монғолиядасыз",
    l_Continue: "Жалғастыру",
    l_Access_to_geodata_is_not_allowed: "Геодеректерге қол жеткізу рұқсат етілмеген. Орналасқан жеріңізді анықтау мүмкін емес",
    l_Location_information_is_unavailable: "Орналасқан жер туралы ақпарат қолжетімді емес.",
    l_your_bday: "Туған жыл, ай, күніңіз",
    l_knowledge: "Біліміңіз",
    l_is_there_experience: "Бизнесті жүргізу, адамдарды басқару және ұйымдастыруда тәжірибеңіз бар ма?",
    l_is_there_2million: "Филиал ашуға орта есеппен 2млн басталатын алғашқы жарнаңыз бар ма?",
    l_Lower: "Арнайы кәсіптік",
    l_Middle: "Орта білім",
    l_Upper: "Жоғары",
    l_Add_partners: "Серіктес қосу",
    l_Communication: "Хабарласу",
    l_Area_covered: "Қамтылатын аймақ",
    l_Document_service: "Құжат қызметі",
    l_The_shelf_number_should_start_with_JP: "Сөре нөмірі JP басталу керек",
    l_All_near_branches: "Барлық жақын орналасқан филиалдар",
    l_Important: "Жаңалық",
    l_New_station: "Жаңа бөлімше ашу",
    l_Branch_near_by: "Жақын жерде орналасқан филиалдар",
    l_Branch_open_warehouse: "Ашылған филиалдар",
    l_Need_branch: "Филиалды таңдау керек",
    l_Daily_Count_Stats: "Күндік көрсеткіш",
    l_Agreement_branch: "Келісімшарт (Бөлімше)",
    l_Agreement_sign: "Келісімшартқа қол қою",
    l_Batch_not_installed: "Batch салынбаған",
    l_Excel_print: "Excel шығару(тапсырыс)",
    l_Reading_list: "Оқығандар тізімі",
    l_Marketing: "Маркетинг",
    l_Number: "Саны",
    l_Home_delivery: "Үйге жеткізу",
    l_Matching: "Сәйкестендіру",
    l_Call_center: "Call center",
    l_Track_analytic: "Тапсырыс аналитикасы",
    l_On_the_shelf: "Сөреде",
    l_Delivered: "Жеткізілді",
    l_Available_offers: "Қолжетімді ұсыныстар",
    l_Courier: "Курьер",
    l_Enabled: "Ашық",
    l_Disabled: "Жабық",
    l_Identification_to_branch: "Филиалына сәйкестендіру",
    l_Personal: "Жеке",
    l_Finished_the_job: "Жұмысты аяқтады",
    l_Completeness: "Тұтастық",
    l_Timeliness: "Уақыттылығы",
    l_Timeliness_24h: "Уақыттылығы 24 сағат",
    l_On_time_delivery: "Уақытылы жеткізу",
    l_On_time: "Уақытылы",
    l_Late: "Кеш",
    l_Total: "Барлығы",
    l_Percent: "Пайыз",
    l_Margin: "Маржа",
    l_Loss: "Шығын",
    l_Income: "Табыс",
    l_Today: "Бүгін",
    l_Yesterday: "Кеше",
    l_Day_before_yesterday: "Алдыңғы күні",
    l_Last_status: "Соңғы статус",
    l_Static_tracks: "Қозғалыссыз тапсырыстар",
    l_Preparation_for_distribution: "Бөлуге дайындау",
    l_Mini_batch_destination: "M-Batch баратын бөлімше",
    l_Not_matched_stations: "Филиал сәйкес емес тауарлар",
    l_Count_order_mbatch: "M-Batch барлық тауар саны",
    l_No_branches_choosed: "Бөлімше таңдалмаған",
    l_Agree_to_change_branches: "Батырманы басып, сіз барлық тауардың филиалын осы M-Btach таңдаған филиалға ауыстырасыз",
    l_Change: "Өзгерту",
    l_Distribution_to_the_basket: "Себетке бөлу",
    l_Coordinate_status: "Координаталық күй",
    l_Delivery_status: "Жеткізу күйі",
    l_Number_of_baskets: "Себеттер саны",
    l_Basket_add: "Себетке қою",
    l_Basket_number: "Себет номері",
    l_Courier_reseived: "Курьер алды",
    l_Courier_didnt_reseived: "Курьер алмады",
    l_Courier_jpcr: "Курьер JPCR",
    l_Need_to_scan_the_courier_JPCR: "Курьер JPCR-ды сканерлеу керек",
    l_Need_to_scan_the_basket_number: "Себет нөмірін сканерлеу керек",
    l_First_scan_the_basket_number_to_check_the_status: "Cебет нөмірін сканерлеп, статусын тексеруге болады",
    l_Last_time: "Соңғы өзгеріс",
    l_Clear: "Тазалау",
    l_Basket_list: "Себет тізімі",
    l_Withdrawal_of_an_order: "Тапсырысты қайтарып алу",
    l_Basket: "Себет",
    l_Adding_an_order_to_the_shelf: "Тапсырысты сөреге қосу",
    l_Distribution_of_the_order_in_the_basket: "Тапсырысты себетке бөлу",
    l_Couriers: "Курьерлер",
    l_To_divide_the_basket_you_need_to_add_the_order_to_the_shelf: 'Тапсырысты себетке бөлу үшін тапсырысты сөреге қосу керек немесе жеткізі күйі "Бөлу дайындалуда" болу керек !  ',
    l_Only_those_whose_coordinates_are_found_are_allocated_in_the_basket: "Координаталары табылғандар ғана себетке бөлінеді",
    l_Orders_in_the_basket: "Себеттегі тапсырыстар",
    l_Courier_refused: "Курьер бас тартты",
    l_Recommended_basket: "Ұсынылған себет",
    l_Number_of_goods_in_preparation_for_distribution: "Бөлуге дайындалудағы тауарлар саны",
    l_Frozen_state: "Мұздатылған күйі",
    l_Be_careful_when_freezing_the_order: "Тапсырысты мұздатқан кезде абай болыңыз !",
    l_Branch_orders: "Филиал тапсырыстары",
    l_Problem_description: "Мәселенің сипаттамасы",
    l_Go_to_website: "Сайтқа өту",
    l_Invite_list: "Шақырылғандар тізімі",
    l_Inviter_JPID: "Шақырушының JPID",
    l_Add_order_to_the_Basket: "Себетке тапсырысты қосу",
    l_Preparing_the_basket_in_the_order: "Тапсырысты себетке дайындау",
    l_Write_the_number_of_the_basket_where_the_orders_will_be_placed: "Тапсырыстар орналасатын себет нөмірін жазыңыз!",
    l_Order_withdrawal_from_courier: "Курьерден қайтарып алу",
    l_Distribution_of_the_order_to_the_courier_shelf: "Тапсырысты курьер сөресіне бөлу",
    l_Courier_shelf_list: "Курьерлік сөре тізімі",
    l_Orders_on_the_courier_shelf: "Курьер сөресіндегі тапсырыстар",
    l_Placing_the_order_on_the_courier_shelf: "Тапсырысты курьерлік сөреге қою",
    l_Courier_shelf_number: "Курьерлік сөре нөмірі",
    l_Preparing_the_order_for_the_courier_shelf: "Тапсырысты курьер сөресіне дайындау",
    l_Adding_an_order_to_the_courier_shelf: "Курьерлік сөреге тапсырыс қосу",
    l_Place_on_the_courier_shelf: "Курьер сөресіне қою",
    l_Allocation_to_the_courier_rack: "Курьер сөресіне бөлу",
    l_Division_into_shelves: "Сөреге бөлу",
    l_Shipping_price: "Жеткізу бағасы",
    l_Cost_price: "Өзіндік құн",
    l_NORTH: "СОЛТҮСТІК",
    l_SOUTH: "ОҢТҮСТІК",
    l_WEST: "БАТЫС",
    l_EAST: "ШЫҒЫС",
    l_Door: "Үйге жеткізу",
    l_Over45days: "45 күннен асқан",
    l_Text: "Текст",
    l_Order_rectify: "Тапсырысты жөндеу",
    l_Not_received: "Алынбады",
    l_Department: "Бөлім",
    l_Operation_time: "Операциялық уақыт",
    l_Tracks: "Тректер",
    l_Adding_a_courier_order: "Курьерге тапсырыс қосу",
    l_Sending_to_courier: "Курьерге жіберу",
    l_Regulation: "Реттеу",
    l_Orders_that_should_be_frozen: "Мұздату керек тапсырыстар",
    l_On_the_courier: "Курьерде",
    l_Goods_older_than_15_days: "15 күннен асқан тауарлар",
    l_Frozen: "Мұздатылған",
    l_Late_delivered_orders: "Кеш жеткізілген тапсырыстар",
    l_More_details: "Толығырақ",
    l_Number_of_days: "Күндер саны",
    l_Undelivered_goods: "Жеткізілмеген тауарлар",
    l_Client_received: "Клиент алды",
    l_Stuck_orders: "Тұрып қалған тапсырыстар",
    l_Check: "Тексеру",
    l_District: "Аудан",
    l_Store: "Дүкен",
    l_Route: "Рейс",
    l_Branch_batch_count: "Branch batch саны",
    l_Last_freeze_day: "Соңғы мұздату күні",
    l_Level: "Деңгей",
    l_Undelivered: "Жеткізілмеген",
    l_New_user: "Жаңа қолданушы",
    l_Sending_a_verification_code_to_the_client: "Клиентке растау кодын жіберу",
    l_Confirmation_code: "Растау коды",
    l_Transit_count: "Транзит саны",
    l_Wrong_tracks: "Қате тректер",
    l_Normal_tracks: "Қалыпты тректер",
    l_Goods_lost_or_broken: "Тауар жоғалды немесе сынды",
    l_Load_data: "Деректерді жүктеу",
    l_China_storage: "Қытай қоймасы",
    l_Inner_logistics: "Ішкі логистика",
    l_Warning: "Ескерту",
    l_Penalty: "Штраф",
    l_Day_left_to_return: "Қайтаруға күн қалды",
    l_Reason_for_rejection: "Бастарту себебі",
    l_Rejection: "Бастарту",
    l_DepartmentId: "Төлеуші бөлім",
    l_Patronymic: "Әкесінің аты",
    l_Inviter: "Шақырушы",
    l_Awaiting_a_refund: "Ақша қайтаруды күтуде",
    l_Send_push_message: "Push-хабарлама жіберу",
    l_Order_search: "Тапсырыс іздеу",
    l_Unclaimed_goods: "Иесіз тауар",
    l_Confirm_Modify: "Өзгерісті растау",
    l_Payment_time: "Төлем уақыты",
    l_Exported: "Жолға шықты",
    l_Arrival_transfer_center: "Трансфер орталына жетті (Қорғас)",
    l_Export_clearance_start: "Экспорттық кедендік рәсімдеу басталды",
    l_Export_clearance_finish: "Экспортқа кедендік рәсімдеу аяқталды",
    l_Departure_foreign: "Шетелден шықты",
    l_Reached_Kazakhstan: "Қазақстанға жетті",
    l_Import_clearance_start: "Импорттық кедендік рәсімдеу басталды",
    l_Import_clearance_finish: "Импорттық кедендік рәсімдеу аяқталды",
    l_Package_status: "Қаптама күйі",
    l_Arrival_branch: "Бөлімшеге жетті",
    l_KZ_mini_batch_products: "KZ mini batch салынған тауарлар",
    l_Scanned: "Сканерленген",
    l_More: "Көбірек",
    l_Registered_user: "Тіркелген",
    l_Copied: "Көшірілді!",
    l_The_first: "Алғашқы",
    l_Current: "Қазіргі",
    l_JPID_change_history: "JPID өзгерту тарихы",
    l_Change_weight: "Салмақты өзгерту",
    l_Not_exists: "Табылмады",
    l_Total_refund_price_usd: "Жалпы қайтару бағасын енгізу",
    l_Order_finish_warning: "Тапсырысты аяқтағаннан кейін өзгерту мүмкін емес. Жібермес бұрын оны мұқият қарастырыңыз!",
    l_Client_address: "Клиенттің мекенжайы",
    l_Client_history: "Тұтынушы тарихы",
    l_Order_history: "Тапсырыс тарихы",
    l_Change_JPID: "JPID өзгерту",
    l_New: "Жаңа",
    l_Old: "Ескі",
    l_Order_JPID_history: "JPID өзгеру тарихы",
    l_Order_branch_history: "Бөлімше өзгеру тарихы",
    l_Client_branch_history: "Клиенттің бөлімше өзгеру тарихы",
    l_Day_delivered: "күнде жеткізілді",
    l_Day_delivering: "күн жеткізілуде",
    l_Free_shipping: "Тегін жеткізу",
    l_Status_history: "Статус тарихы",
    l_Transit_branch: "Транзит бөлімше",
    l_Failed_to_copy: "Көшіру сәтсіз аяқталды",
    l_Please_enter: "Енгізіңіз",
    l_Max_day_count: "Максималды күн саны",
    l_Payment_complaint: "Төлем шағымы",
    l_Copy: "Көшіру",
    l_Hidden: "Жасырын",
    l_Are_you_sure_you_want_to_perform_this_action: "Осы әрекетті орындауға сенімдісіз бе?",
    l_Show_order_to_client: "Осы әрекет арқылы тауар клиентке қайта көрінеді!",
    l_Courier_operation: "Курьер әрекеті",
    l_Start_date: "Басталу күні",
    l_End_date: "Аяқталу күні",
    l_The_client_agreed: "Kлиент келісті",
    l_Cancelled: "Бас тартылды",
    l_Te_client_refused: "Kлиент бас тартты",
    l_Cancel2: "Бас тарту",
    l_Additional_payment: "Қосымша төлем",
    l_Additional_packaging: "Қосымша қаптама",
    l_China_inner_logistics: "Қытай ішкі логистикасы",
    l_Payment_type: "Төлем типі",
    l_Error_500: "Сервердің ішкі қатесі. Кейінірек қайталап көріңіз.",
    l_Show_more: "Толығырақ көрсету",
    l_Oversized: "Көлемі үлкен",
    l_Overweight: "Салмағы ауыр",
    l_Transport_restrictions: "Тасымалдауға тыйым салынған",
    l_Cash_on_delivery: "Тасымалдаушыға төлем",
    l_Non_original_packaging: "Түпнұсқа қаптама/сыртқы қаптама болмаған",
    l_Return_requested: "Қайтару сұралды",
    l_Damaged: "Зақымдалған",
    l_Pre_creation_reject: "Құрылу алдында бас тартылды",
    l_Sent_for_feedback: "Кері байланысқа жіберілген тапсырыс",
    l_In_search: "Ізделуде",
    l_Found: "Табылды",
    l_More_than_72_hours: "72 сағаттан асты",
    l_Weight_measured: "Салмағы өлшенді",
    l_Avg_measure_duration: "Орташа салмағын өлшеу уақыты",
    l_China_courier_operation: "Қытай курьері тасымалдауда",
    l_Code_wrong: "Код қате",
    l_Returned_order: "Бастартылған тапсырыс",
    l_Wrong_address: "Қате мекен-жай",
    l_Warehouse_not_accepted: "Қойма қабылдамаған",
    l_Wrong_client: "Қате клиент",
    l_China_warehouse_shelf: "Қытай қоймасында сөреге қойылды",
    l_Deleted: "Жойылды",
    l_Found_time: "Табылды уақыты",
    l_Measure_duration: "Уақыт айырмашылығы",
    l_Weight_measured_time: "Салмағын өлшеу уақыты",
    l_Found_items: "Табылған тауарлар",
    l_Weight_not_measured: "Салмағы өлшенбеген",
    l_Overdue_sla_72h: "72 сағаттан асты",
    l_Dashboard_period: "Статистика уақыты",
    l_Enter_track_code: "Трек-код енгізіңіз",
    l_Enter_jpid: "JPID енгізіңіз",
    l_Promocode: "Промокод",
    l_Registered: "Тіркелген",
    l_Inviter_user: "Шақырған",
    l_Invited_by: "Шақырылған",
    l_Invited_friends: "Шақырылған достар",
    l_Friend: "Дос",
    l_Promo_code_entered: "Промокод қолданған",
    l_Expired_bonus: "Жанған бонус",
    l_Total_accrued: "Барлығы есептелген",
    l_Referral_balance: 'Баланс "Дос шақыру"',
    l_First_delivery: "Бірінші жеткізу",
    l_Not_placed_yet: "Әлі рәсімделген жоқ",
    l_Used_promocode: "Қолданылған промокод",
    l_Used_bonus: "Қолданылған бонус",
    l_Bonus_statuses: "Бонус статустары",
    l_Expired: "Күйген",
    l_Promo_type_user: "USER",
    l_After_registration: "Тіркелгеннен кейін",
    l_First_delivery_bonus_hint: "Бірінші жеткізу қытай қоймасында тіркелгеннен кейін есептеледі",
    l_For_first_delivery: "Бірінші жеткізу үшін",
    l_First_delivery_deadline: "Бірінші жеткізуге мерзім",
    l_Promo_type: "Түрі",
    l_Inviting_client: "Шақырған клиент",
    l_Deadline_until: "Мерзімі",
    l_Promo_type_system: "SYSTEM",
    l_Accrued: "Есептелген",
    l_Not_accrued: "Есептелмеген",
    l_Placed: "Жеткізілген",
    l_Minutes_short: "мин.",
    l_Hours_short: "с.",
    l_Days_short: "күн",
    l_Days_left: "күн қалды",
    l_Registration_type: "Тіркелу түрі",
    l_Automatic: "Автоматты",
    l_Manual: "Қолмен",
    l_Rejected_orders: "Мәселелі тапсырыс",
    l_Died_orders: "Өлі тауарлар (DIED)",
    l_Branch_2_door: "ПВЗ-Door",
    l_Related_orders_warning: "Бұл тапсырыс басқа тапсырыстармен ({count}) бір жөнелтілімде. Өзгерістер төмендегі тапсырыстарға да қолданылады. Жалғастырасыз ба?",
}
